const features = [
  {
    icon: 'ri-book-read-line',
    title: '海量韩漫资源',
    desc: '收录超过3200部韩国漫画，从热门连载到经典完结，应有尽有。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '下拉式阅读',
    desc: '专为移动端优化的下拉式阅读方式，流畅顺滑，无需翻页。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '每日极速更新',
    desc: '与韩国平台同步更新，确保你第一时间看到最新章节内容。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '完全免费',
    desc: '所有漫画资源完全免费阅读，无需订阅，无需付费，畅享全部内容。',
  },
  {
    icon: 'ri-palette-line',
    title: '高清画质',
    desc: '全部漫画均为高清扫描版本，色彩还原度高，阅读体验极佳。',
  },
  {
    icon: 'ri-heart-line',
    title: '个性化推荐',
    desc: '智能推荐系统，根据你的阅读偏好为你推荐最合适的漫画作品。',
  },
];

export default function FeatureGrid() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto text-center">
        <span className="inline-block px-4 py-1.5 rounded-full border border-primary-300 text-primary-600 text-sm mb-6 whitespace-nowrap">
          为什么选择我们
        </span>
        <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 mb-4">
          极致的韩漫阅读体验
        </h2>
        <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto mb-12">
          我们致力于为每一位韩漫爱好者打造最舒适、最便捷的在线阅读平台
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-5">
          {features.map((feat, i) => (
            <div
              key={i}
              className="group text-left p-6 md:p-5 rounded-lg bg-background-100 hover:bg-primary-500 transition-colors duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-background-200 rounded-lg mb-4 group-hover:bg-background-50/20 transition-colors">
                <i className={`${feat.icon} text-xl text-primary-500 group-hover:text-background-50 transition-colors`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-950 group-hover:text-background-50 mb-2 transition-colors">
                {feat.title}
              </h3>
              <p className="text-sm text-foreground-600 group-hover:text-background-50/80 transition-colors leading-relaxed">
                {feat.desc}
              </p>
              <div className="mt-4 flex items-center gap-1 text-primary-500 group-hover:text-background-50 text-sm font-medium transition-colors">
                <span>了解更多</span>
                <i className="ri-arrow-right-line"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}